
import { red } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  radioGroup: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '-10px',
  },
  button: {
    marginTop: '1px',
    marginBottom:'0px',
    /*backgroundColor:'Teal',*/
    /*background: 'linear-gradient(to right, #ff416c, #ff4b2b)', // Gradient colors
    color: 'white',
    '&:hover': {
      background: 'linear-gradient(to right, #ff4b2b, #ff416c)', // Gradient colors on hover
    },*/
  },
  
  
}));